import e from "./_xfBase.mjs";
var u = /* @__PURE__ */ function() {
  function t(r, n) {
    this.xf = n, this.f = r;
  }
  return t.prototype["@@transducer/init"] = e.init, t.prototype["@@transducer/result"] = e.result, t.prototype["@@transducer/step"] = function(r, n) {
    return this.xf["@@transducer/step"](r, this.f(n));
  }, t;
}(), o = function(r) {
  return function(n) {
    return new u(r, n);
  };
};
export {
  o as default
};
